import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ParametersService } from '../../services/parameters.service';
import { Country } from '../../model/parameters.model';
import { Address } from '../../model/account.model';

@Component({
    selector: 'jhi-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class AddressComponent implements OnInit, OnDestroy {

    @Input()
    address: Address;

    @Input()
    isCreateAccountBtnClicked: boolean;

    countries: Array<Country>;

    private subscription: Subscription;

    constructor(private parametersService: ParametersService) {}

    ngOnInit(): void {
        this.subscription = this.parametersService
            .getParameters()
            .subscribe(parameters => (this.countries = parameters.countries));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/address/address.component.ts